"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDownloadPdfCatalog = void 0;
const react_1 = require("react");
const useFeatureFlag_1 = require("../useFeatureFlag");
const brand_provider_1 = require("../../providers/brand.provider");
const useDownloadPdfCatalog = () => {
    const [pdfUrlConfig, loading] = (0, useFeatureFlag_1.useFeatureFlag)('pdfCatalogUrl', '');
    const pdfCatalogUrl = (0, react_1.useMemo)(() => {
        if (loading || !pdfUrlConfig) {
            return null;
        }
        const parsedConfig = JSON.parse(pdfUrlConfig);
        if (!Object.keys(parsedConfig).length) {
            return null;
        }
        const url = parsedConfig[brand_provider_1.BrandProvider.getBrand()];
        return url;
    }, [loading]);
    return pdfCatalogUrl;
};
exports.useDownloadPdfCatalog = useDownloadPdfCatalog;
